import { useEffect } from 'react';

interface VideoModalProps {
  open: boolean;
  title: string;
  poster?: string;
  onClose: () => void;
}

export default function VideoModal({ open, title, poster, onClose }: VideoModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', onKey);
    }
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-primary-950/80 backdrop-blur-sm animate-zoom-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl rounded-lg overflow-hidden bg-background-950 border border-white/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <div className="flex items-center gap-2 min-w-0">
            <i className="ri-movie-2-line text-accent-400"></i>
            <span className="font-heading font-semibold text-sm text-white truncate">{title}</span>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-md flex items-center justify-center text-background-200 hover:bg-white/10 transition-colors cursor-pointer shrink-0"
            aria-label="关闭"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="relative w-full aspect-video bg-black">
          {poster ? (
            <img
              src={poster}
              alt={`${title} 播放预览`}
              className="w-full h-full object-cover opacity-30"
            />
          ) : null}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <span className="w-16 h-16 rounded-full bg-accent-500/90 flex items-center justify-center mb-4">
              <i className="ri-play-fill text-white text-3xl ml-1"></i>
            </span>
            <p className="font-heading font-semibold text-white text-base md:text-lg">{title}</p>
            <p className="text-background-300 text-sm mt-2 max-w-md">
              该播放区域为前端演示效果，仅供页面展示，不支持真实播放或资源下载。
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between px-4 py-3 text-xs text-background-300">
          <span className="flex items-center gap-1.5">
            <i className="ri-information-line"></i> 演示模式
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-hd-line"></i> 高清 1080P（示例）
          </span>
        </div>
      </div>
    </div>
  );
}